(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("dayjs"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "dayjs", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["bonree-design-antd"] = factory(require("react"), require("dayjs"), require("react-dom"));
	else
		root["bonree-design-antd"] = factory(root["React"], root["dayjs"], root["ReactDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__5__) {
return 